(ns frontend.ui.component.lp-portal.report.component.block-table.view
  (:require
   [common.localization :as loc]
   [frontend.ui.component.lp-portal.voima-components.card.view :as card]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.style :as style]
   [frontend.ui.component.lp-portal.voima-components.text-content.view :as text-content]
   [frontend.ui.style.theme.core :as theme]
   [herb.core :as h]))

(defn data-row-tabular
  [row idx
   {:keys [parsed-data even-row-background-color
           odd-row-background-color
           heading-color heading-info-color
           sub-heading-color sub-total-color total-color empty-line-color
           tabular-data-alignment] :as props}]
  (let [{:keys [row-data row-highlight row-type row-font-style row-style]} row
        {:keys [column-font-style-row table-style]} parsed-data
        data-heading (first row-data)
        data-value (rest row-data)
        data-type :table-data-type/text ;;block table data is always text type
        row-idx (if (= row-type "subtotal")
                  0
                  idx)]
    (cond
      (= row-type "heading") [:tr {:class (h/<class style/heading-tr)}
                              [:th
                               {:class    (h/<class style/th-heading nil 0 data-type)
                                :col-span 2} data-heading]]
      (= row-type "heading info") [:tr {:class (h/<class style/heading-tr)}
                                   [:th
                                    {:class    (h/<class style/th-info nil 0 nil)
                                     :col-span 2
                                     :style    {:text-align "left"}} data-heading]]
      (= row-type "subheading") [:tr {:class (h/<class style/heading-tr)}
                                 [:th
                                  {:class    (h/<class style/th-heading nil 0 data-type)
                                   :col-span 2} data-heading]]
      :else
      [:tr
       {:class (h/<class style/data-row-block-table-tabular
                         row-type
                         row-highlight
                         row-font-style
                         row-style
                         row-idx
                         even-row-background-color
                         odd-row-background-color
                         heading-color
                         heading-info-color
                         sub-heading-color
                         sub-total-color
                         total-color
                         empty-line-color
                         table-style)}
       [:td
        {:class (h/<class
                 (partial style/data-row-td
                          "left"
                          nil
                          nil
                          (nth column-font-style-row 0 nil)
                          nil
                          nil
                          props))}
        data-heading]
       [:td
        {:class (h/<class
                 (partial style/data-row-td
                          (when tabular-data-alignment tabular-data-alignment)
                          nil
                          nil
                          (nth column-font-style-row 1 nil)
                          nil
                          nil
                          props))}
        data-value]])))

(defn data-row-stacked
  [{:keys [_headers
           column-font-style-row
           _heading-count _rows _table-row-alignment]} row]
  (let [{:keys [row-data row-highlight row-type row-font-style]} row
        data-heading (first row-data)
        data-value (rest row-data)]
    [:<>
     [:tr {:class (h/<class style/data-row-block-table-stacked row-type row-highlight row-font-style)}
      [:td {:class (h/<class style/data-row-td-heading-stacked (nth column-font-style-row 0 nil) row-type)} data-heading]]
     [:tr
      [:td {:class (h/<class style/td-stacked)} data-value]]]))

(defn dynamic-table
  [{:keys [parsed-data]
    :as   props}]
  (let [{:keys [table-row-alignment rows]}
        parsed-data]
    (if-not rows
      [:div (loc/tr :lp-report-template-incorrect-table-data)]
      [:div

       [:table {:class (h/<class style/dynamic-table props)}
        (when (pos? (count rows))
          (into [:tbody]
                (->> rows
                     (map-indexed
                      (fn [idx row]
                        (case table-row-alignment
                          "tabular"
                          (data-row-tabular row idx props)
                          "stacked"
                          (data-row-stacked parsed-data row)))))))]])))

(defn table
  [name
   {:keys [_rich-content _rich-content-path _figures] :as data}
   {:keys [_edit-mode? _save-text] :as props}]
  (let [removed-since-empty? (->> data
                                  :figures
                                  :rows
                                  (filter (fn [{:keys [row-data]}]
                                            (seq (remove nil? row-data))))
                                  (count)
                                  (= 0))]
    (if (and (not (:edit-mode? props))
             removed-since-empty?)
      nil
      [card/expandable-card
       (merge props
              {:removed-since-empty? removed-since-empty?
               :title (if removed-since-empty?
                        "No data provided (table will be hidden)"
                        name)})
       [:<>
        [dynamic-table
         {:parsed-data              (:figures data)
          :odd-row-background-color (theme/color [:lp-report :table :odd-row :bg])
          :even-row-background-color (theme/color [:lp-report :table :even-row :bg])
          :heading-color            (theme/color [:lp-report :table :heading-color :bg])
          :heading-info-color       (theme/color [:lp-report :table :heading-info-color :bg])
          :sub-heading-color        (theme/color [:lp-report :table :subheading-color :bg])
          :sub-total-color          (theme/color [:lp-report :table :subtotal-color :bg])
          :total-color              (theme/color [:lp-report :table :total-color :bg])
          :empty-line-color         (theme/color [:lp-report :table :empty-line-color :bg])
          :fixed-width?             (:fixed-width? props)
          :tabular-data-alignment   (:tabular-data-alignment props)}]
        (when-not (or (:hide-footnote? props) removed-since-empty?) (text-content/optional-footnote data props))]])))
